const mutations = {
  UPDATE_USER_INFO(state, payload) {
    state.user = payload;
  },

  UPDATE_IS_LOGGED_IN(state, val) {
    state.isLoggedIn = val;
  },
};

export default mutations;
